export default __webpack_public_path__ + "static/media/msg_icon-1.e1c7030a.svg";